import {createSlice} from '@reduxjs/toolkit';

const initialState =  {
  isForgotPassword: false,
  choiceState: false,
}

const modals = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    showForgotPasswordModalAction(state, action) {
      state.isForgotPassword = true;
    },

    hideForgotPasswordModalAction(state, action) {
      state.isForgotPassword = false;
    },

    showChoiceStateModalAction(state, action) {
      state.choiceState = true;
    },

    hideChoiceStateModalAction(state, action) {
      state.choiceState = false;
    },
  },
});

export default modals.reducer;
export const {
  showForgotPasswordModalAction,
  hideForgotPasswordModalAction,
  showChoiceStateModalAction,
  hideChoiceStateModalAction
} = modals.actions